import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { ApiHelper } from './apiHelper';

@Injectable()
export class StatusService {
  constructor(private apiHelper: ApiHelper) {}

  public apiStatus(): Observable<{ version: string }> {
    const url: string = this.apiHelper.getServiceName() + 'status/api/version';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{ version: string }>(
      url,
      method,
      null,
      null,
      headers,
    );
  }
}
